import React, { useState, useEffect } from "react";
import Switch from '@mui/material/Switch';
import { useHistory } from "react-router-dom";
import {
  Grid,
  Button,
  Typography,
  ListItem,
} from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import PageHeader from "../../../Components/PageHeader";
import LeftControl from "../../../Components/LeftControl";
import Snackbar from '../../../Components/Snackbar';
import Services from '../../../Services';
import PageLayout from "../../../Components/LayoutComponents/PageLayout";


const label = { inputProps: { 'aria-label': 'Switch demo' } };

const { hr } = Services;

const EmployeeLookup = () => {

  let history = useHistory();
  const [id, setId] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [isLoadingEmployees, setIsLoadingEmployees] = useState(false);
  const [error, setError] = useState(false);
  const [employeesList, setEmployeesList] = useState([]);
  const [employeeSwitch, setEmployeeSwitch] = useState(true);
  const timeouts = { employeesRetreival: null }

  useEffect(() => {
    window.scrollTo(0, 0);

    (async () => {
      if (!employeeName) {
        setIsLoadingEmployees(false);
        setEmployeesList([]);
        return false;
      }

      try {
        const list = await hr.getAllApplicantsByName({ name: employeeName, status: employeeSwitch });

        const { employee: employeesList } = list;

        setEmployeesList(employeesList);

        clearTimeout(timeouts.employeesRetreival);

        setTimeout(() => {
          setIsLoadingEmployees(false);
        }, 0);

      } catch (exc) {

      }
    })();
  }, [employeeName]);

  async function onSubmit(event, forcedIdParam = '') {
    if (event)
      event.preventDefault();

    const useId = (id || forcedIdParam).toString();
    if (useId) {
      let data = {
        id: useId,
        status: employeeSwitch
      }
      try {
        let data1 = await hr.getEmployee(data);
        history.push({
          pathname: "/employees/result",
          state: data1,
        });
      }
      catch (exc) { }
    }
    else setError(!error)

  }
  const onToggleChange = () => {
    setEmployeeSwitch(!employeeSwitch);
  };

  return (
    <PageLayout className="Liq-Container HRPortal">
      <Snackbar></Snackbar>
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">Employee Lookup</Grid>
        <Grid xs={12} className="ContentPage BlueHeadTable FormTableArea">
          <Grid xs={12}>
            <Grid xs={12} md={8} lg={6} container className="HREmSearch">
              <Grid xs={6}>
                <Typography style={{ marginTop: '15px' }}>All Employees and Applicant</Typography>
                <Switch {...label} onClick={onToggleChange} />
              </Grid>
              <form style={{ width: '100%' }} onClick={onSubmit}>
                <Grid style={{ marginTop: '10px' }} xs={12}>
                  <Typography>Employee ID</Typography>
                  <TextField id="outlined-basic" value={id} onChange={(e) => { setId(e.target.value) }} variant="outlined" className="w100p" autoComplete="off" />
                  <p style={{ display: error == true ? "block" : "none", fontSize: "10px", color: "red" }}>Id is required</p>
                </Grid>
                <Grid style={{ marginTop: '10px' }} xs={12}>
                  <Typography>Employee Name <span style={{ fontSize: "10px" }}>(Search by name)</span></Typography>
                  <TextField id="outlined-basic" onChange={(e) => {
                    setIsLoadingEmployees(true);
                    setEmployeeName(e.target.value);
                  }} variant="outlined" className="w100p" autoComplete="off" />
                </Grid>
                {
                  (isLoadingEmployees)
                    ? (
                      <Grid>
                        Retreiving List ...
                      </Grid>
                    )
                    : <Grid></Grid>

                }

                {
                  (!isLoadingEmployees && employeesList.length)
                    ? <Grid className='employees-list'>
                      {
                        employeesList.map(employee => {
                          return (
                            <ListItem style={{
                              'box-shadow': '1px 1px 15px -10px #555'
                            }}>
                              <Typography style={{ flex: 1 }}>ID: {employee.id}</Typography>
                              <Typography style={{ flex: 6 }}>{employee.firstName} {employee.lastName}</Typography>
                              <Button style={{
                                flex: 1,
                                background: '#2963AD',
                                color: 'white',
                              }}
                                type="submit"
                                onClick={(event) => {
                                  setId(employee.id);
                                  onSubmit(event, employee.id);
                                }}>
                                View
                              </Button>
                            </ListItem>
                          )
                        })
                      }
                    </Grid>
                    : <Grid></Grid>
                }


                <Grid xs={4}>
                  <Typography className="SearchBtnDot">.</Typography>
                  <Button style={{ background: '#2963AD', color: 'white' }} type='submit' >Search</Button>
                </Grid>

              </form>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PageLayout>
  );
}

export default EmployeeLookup;